import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  // constructor(private messageService: NzMessageService, private notifyService: NzNotificationService) { }
  constructor() { }
  message(type: string, msg: string, time?: number) {
    // this.messageService.create(type, msg, { nzDuration: time ? time : 3000 });
  }
  notify(type: string, title: string, msg: string, position?: any, time?: number) {
    // this.notifyService.create(type, title, msg, { nzPlacement: position ? position : 'bottomRight' , nzDuration: time ? time : 3000 });
  }
  // if get type is not from this ( 'error', 'success', 'warning' ) then make function for these validation or default 
  // need to validate position in notify
}
